/* TF Find My Tire v3 (Horizon). Modal + size cascade.
   Data: #fmt-data JSON rendered by sections/tf-find-my-tire.liquid
   (routes, caps, tree = shop.metafields.custom.tire_finder_data).
   Modes: size (metric), diam (flotation), inch (width + rim), alpha (tire_size code).
   Every option comes from the builder scan, so every search lands on real products. */
(function () {
  if (window.tfFinderLoaded) return;
  window.tfFinderLoaded = true;

  var RECENT_KEY = 'tfFinderRecent', CAT_KEY = 'tfFinderCat';
  function f(n) { var x = parseFloat(n); if (isNaN(x)) return String(n); return x === Math.floor(x) ? String(Math.floor(x)) : String(x); }
  function inch(n) { var x = parseFloat(n); return isNaN(x) ? String(n) : x.toFixed(2); }
  function pDec(n) { var x = parseFloat(n); if (isNaN(x)) return String(n); return x === Math.floor(x) ? (Math.floor(x) + '.0') : String(x); }
  function pInt(n) { var x = parseFloat(n); return isNaN(x) ? String(n) : String(Math.round(x)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var MODE_LABEL = { size: 'Metric', inch: 'Inch', alpha: 'Alpha', diam: 'Flotation' };
  var SEGS = { size: ['Width', 'Ratio', 'Rim'], diam: ['Height', 'Width', 'Rim'], inch: ['Width', 'Rim'], alpha: ['Size'] };
  function seps(cat, mode) {
    if (mode === 'size') return cat === 'motorcycle' ? ['/', '\u2013'] : ['/', 'R'];
    if (mode === 'diam') return cat === 'passenger-lt' ? ['\u00d7', 'R'] : ['\u00d7', '\u2013'];
    if (mode === 'inch') return ['\u2013'];
    return [];
  }
  // [value, label, highlight]
  var HELP = {
    'motorcycle:size': [[['180', 'Width', 1], ['/', ''], ['55', 'Ratio', 1], ['ZR', ''], ['17', 'Rim', 1], ['73W', 'Load / speed']], 'Front and rear sizes usually differ. Read each tire and search one at a time.'],
    'motorcycle:inch': [[['4.00', 'Width', 1], ['-', ''], ['18', 'Rim', 1], ['64P', 'Load / speed']], 'Inch sizes are common on dirt, dual sport, scooter, and vintage bikes.'],
    'motorcycle:alpha': [[['MT90', 'Size code', 1], ['B', ''], ['16', 'Rim', 1]], 'Alpha sizes are common on older Harley-Davidson touring and Softail models.'],
    'atv-utv:diam': [[['30', 'Height', 1], ['x', ''], ['10', 'Width', 1], ['R', ''], ['14', 'Rim', 1]], 'All three numbers are inches. ATV fronts and rears are often different sizes.'],
    'trailer:size': [[['ST', ''], ['205', 'Width', 1], ['/', ''], ['75', 'Ratio', 1], ['R', ''], ['15', 'Rim', 1]], 'ST means special trailer. Match the load range on your current tires.'],
    'lawn-garden:diam': [[['20', 'Height', 1], ['x', ''], ['10.00', 'Width', 1], ['-', ''], ['8', 'Rim', 1]], 'All three numbers are inches. On mowers the rear is usually the larger tire.']
  };

  function boot() {
    var modal = document.querySelector('[data-tfm]');
    var dataEl = document.getElementById('fmt-data');
    if (!modal || !dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    DATA.tree = DATA.tree || {}; DATA.routes = DATA.routes || {}; DATA.caps = DATA.caps || {};
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    var q = function (s) { return modal.querySelector(s); };
    var sheet = q('.tfm__sheet'), form = q('.tfm__body');
    var catBtns = Array.prototype.slice.call(modal.querySelectorAll('.tfm__cat'));
    var modesEl = q('.tfm__modes'), helpBtn = q('[data-tfm-help]'), helpBox = q('.tfm__helpbox');
    var segs = Array.prototype.slice.call(modal.querySelectorAll('.tfm__seg'));
    var sels = segs.map(function (s) { return s.querySelector('select'); });
    var segLabels = segs.map(function (s) { return s.querySelector('.tfm__seglabel'); });
    var sepEls = Array.prototype.slice.call(modal.querySelectorAll('.tfm__sep'));
    var go = q('.tfm__go'), goLabel = q('[data-tfm-go-label]'), recentEl = q('.tfm__recent');
    var state = { cat: '', mode: '', v: ['', '', ''] };
    var lastTrigger = null;
    function validCat(c) { return !!c && catBtns.some(function (b) { return b.dataset.cat === c; }) && !!DATA.caps[c]; }

    function rowsFor(cat, mode) {
      var b = DATA.tree[cat] || {};
      if (mode === 'size') return (b.size_triples || []).filter(function (t) { return cat !== 'motorcycle' || t[0] >= 10; });
      if (mode === 'diam') return b.diam_triples || [];
      if (mode === 'inch') return b.inch_pairs || [];
      if (mode === 'alpha') return (b.alpha_sizes || []).map(function (s) { return [s]; });
      return [];
    }
    function options(k) {
      var rows = rowsFor(state.cat, state.mode).filter(function (r) {
        for (var i = 0; i < k; i++) { if (String(r[i]) !== state.v[i]) return false; }
        return true;
      });
      var seen = {}, out = [];
      rows.forEach(function (r) { var key = String(r[k]); if (!seen[key]) { seen[key] = 1; out.push(r[k]); } });
      if (state.mode === 'alpha') return out.sort();
      return out.sort(function (a, b) { return a - b; });
    }
    function label(k, v) { if (state.mode === 'alpha') return v; if (state.mode === 'inch' && k === 0) return inch(v); return f(v); }
    function renderSel(k, opts, ready) {
      var sel = sels[k];
      sel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = '\u2013';
      sel.appendChild(ph);
      opts.forEach(function (v) { var o = document.createElement('option'); o.value = String(v); o.textContent = label(k, v); sel.appendChild(o); });
      var keep = opts.some(function (v) { return String(v) === state.v[k]; });
      if (!keep) state.v[k] = '';
      sel.value = state.v[k];
      sel.disabled = !ready || !opts.length;
      sel.classList.toggle('is-set', state.v[k] !== '');
    }
    function refreshFrom(k) {
      var n = SEGS[state.mode].length;
      for (var i = k; i < n; i++) {
        var ready = i === 0 || state.v[i - 1] !== '';
        var opts = ready ? options(i) : [];
        renderSel(i, opts, ready);
        if (ready && opts.length === 1 && state.v[i] === '') {
          state.v[i] = String(opts[0]); sels[i].value = state.v[i]; sels[i].classList.add('is-set');
        }
      }
      updateGo();
    }
    function complete() { var n = SEGS[state.mode].length; for (var i = 0; i < n; i++) { if (state.v[i] === '') return false; } return !!state.cat; }
    function sizeLabel() {
      var v = state.v;
      if (state.mode === 'size') return state.cat === 'motorcycle' ? f(v[0]) + '/' + f(v[1]) + '-' + f(v[2]) : f(v[0]) + '/' + f(v[1]) + 'R' + f(v[2]);
      if (state.mode === 'diam') return f(v[0]) + 'x' + f(v[1]) + '-' + f(v[2]);
      if (state.mode === 'inch') return inch(v[0]) + '-' + f(v[1]);
      return v[0];
    }
    function updateGo() {
      var ok = complete();
      go.disabled = !ok;
      goLabel.textContent = ok ? 'Show ' + sizeLabel() + ' tires' : 'Select your size';
    }
    function layout() {
      var n = SEGS[state.mode].length, s = seps(state.cat, state.mode);
      segs.forEach(function (seg, i) { seg.hidden = i >= n; if (i < n) { segLabels[i].textContent = SEGS[state.mode][i]; sels[i].setAttribute('aria-label', SEGS[state.mode][i]); } });
      sepEls.forEach(function (sep, i) { sep.hidden = i >= n - 1; sep.textContent = s[i] || ''; });
    }
    function renderHelp() {
      var h = HELP[state.cat + ':' + state.mode];
      if (!h) { helpBox.innerHTML = ''; return; }
      helpBox.innerHTML = '<div class="tfm__ex">' + h[0].map(function (p) {
        return '<span class="tfm__ex-part' + (p[2] ? ' tfm__ex-part--hl' : '') + '"><span class="tfm__ex-v">' + esc(p[0]) + '</span><span class="tfm__ex-k">' + (p[1] ? esc(p[1]) : '&nbsp;') + '</span></span>';
      }).join('') + '</div><p class="tfm__ex-note">' + esc(h[1]) + '</p>';
    }
    function setMode(mode) {
      state.mode = mode; state.v = ['', '', ''];
      Array.prototype.forEach.call(modesEl.querySelectorAll('.tfm__mode'), function (b) { b.setAttribute('aria-selected', b.dataset.mode === mode ? 'true' : 'false'); });
      layout(); renderHelp(); refreshFrom(0);
    }
    function setCat(cat) {
      var caps = DATA.caps[cat];
      if (!caps) return;
      state.cat = cat;
      catBtns.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.cat === cat ? 'true' : 'false'); });
      var paths = (caps.paths || []).filter(function (m) { return rowsFor(cat, m).length > 0; });
      modesEl.innerHTML = paths.map(function (m) { return '<button type="button" class="tfm__mode" role="tab" data-mode="' + m + '" aria-selected="false">' + (MODE_LABEL[m] || m) + '</button>'; }).join('');
      modesEl.hidden = paths.length < 2;
      save(CAT_KEY, cat);
      setMode(paths.indexOf(caps['default']) !== -1 ? caps['default'] : (paths[0] || 'size'));
    }
    function buildUrl() {
      var v = state.v, p;
      if (state.mode === 'size') p = ['tire_width=' + pDec(v[0]), 'tire_aspect_ratio=' + pInt(v[1]), 'tire_rim_diameter=' + pDec(v[2])];
      else if (state.mode === 'diam') p = ['tire_diameter=' + pDec(v[0]), 'tire_width=' + pDec(v[1]), 'tire_rim_diameter=' + pDec(v[2])];
      else if (state.mode === 'inch') p = ['tire_width=' + pDec(v[0]), 'tire_rim_diameter=' + pDec(v[1])];
      else p = ['tire_size=' + encodeURIComponent(v[0])];
      return '/collections/' + DATA.routes[state.cat] + '?' + p.map(function (x) { return 'filter.p.m.custom.' + x; }).join('&');
    }
    function renderRecent() {
      var r = (load(RECENT_KEY) || []).filter(function (x) { return x && typeof x.u === 'string' && x.u.indexOf('/collections/') === 0; });
      if (!r.length) { recentEl.hidden = true; return; }
      recentEl.innerHTML = '<span>Recent</span>' + r.map(function (x) { return '<a class="tfm__chip" href="' + esc(x.u) + '">' + esc(x.l) + '</a>'; }).join('');
      recentEl.hidden = false;
    }

    catBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.dataset.cat !== state.cat) setCat(b.dataset.cat); }); });
    modesEl.addEventListener('click', function (e) { var b = e.target.closest('.tfm__mode'); if (b && b.dataset.mode !== state.mode) setMode(b.dataset.mode); });
    sels.forEach(function (sel, k) {
      sel.addEventListener('change', function () {
        state.v[k] = sel.value;
        for (var j = k + 1; j < 3; j++) state.v[j] = '';
        sel.classList.toggle('is-set', sel.value !== '');
        refreshFrom(k + 1);
      });
    });
    helpBtn.addEventListener('click', function () {
      helpBox.hidden = !helpBox.hidden;
      helpBtn.textContent = helpBox.hidden ? "Where's my size?" : 'Hide help';
      helpBtn.setAttribute('aria-expanded', helpBox.hidden ? 'false' : 'true');
    });
    go.addEventListener('click', function () {
      if (!complete() || !DATA.routes[state.cat]) return;
      var url = buildUrl(), lbl = sizeLabel();
      var r = (load(RECENT_KEY) || []).filter(function (x) { return x && x.u !== url; });
      r.unshift({ l: lbl, u: url });
      save(RECENT_KEY, r.slice(0, 3));
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'tf_finder_search', tf_category: state.cat, tf_mode: state.mode, tf_size: lbl }); } catch (e) {}
      window.location.href = url;
    });

    function open(cat) {
      modal.hidden = false;
      document.body.classList.add('tfm-open');
      renderRecent();
      if (validCat(cat) && cat !== state.cat) setCat(cat);
      if (sheet) sheet.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('tfm-open');
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (e) {} }
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('a[href$="#find-my-tire"], [data-fmt-open], [data-tfm-open]');
      if (!t) return;
      e.preventDefault();
      lastTrigger = t;
      open(t.getAttribute('data-fmt-cat'));
    });
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-tfm-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    // Start category: the page's own category, then the visitor's last one, then the section default.
    var startCat = form.getAttribute('data-context-cat');
    if (!validCat(startCat)) startCat = load(CAT_KEY);
    if (!validCat(startCat)) startCat = form.getAttribute('data-default-cat');
    if (!validCat(startCat)) startCat = 'motorcycle';
    setCat(startCat);
    if (window.location.hash === '#find-my-tire') open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();